// import React, { useState, useEffect } from 'react';
// import swal from 'sweetalert';

// const Settings = ({ user }) => {
//   const [passwordData, setPasswordData] = useState({
//     currentPassword: '',
//     newPassword: '',
//     confirmPassword: '',
//     email: user?.email || '' // Pre-fill with user's email or empty
//   });
//   const [otp, setOtp] = useState('');
//   const [step, setStep] = useState(1); // 1: Password form, 2: OTP verification
//   const [showCurrentPassword, setShowCurrentPassword] = useState(false);
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState({ type: '', text: '' });
//   const [passwordStrength, setPasswordStrength] = useState(0);
//   const [resendCooldown, setResendCooldown] = useState(0);
//   const [userDetails, setUserDetails] = useState(null);
//   const [fetchingUser, setFetchingUser] = useState(false);

//   const API_BASE_URL = "https://dairy.server.statify.co.ke";

//   // Fetch user details including email from backend
//   const fetchUserDetails = async () => {
//     if (!user?.id) return;
    
//     try {
//       setFetchingUser(true);
//       const token = localStorage.getItem('token');
      
//       if (!token) {
//         console.warn('No authentication token found');
//         return;
//       }

//       const response = await fetch(`${API_BASE_URL}/api/users/${user.id}`, {
//         method: 'GET',
//         headers: { 
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`
//         },
//       });

//       if (response.ok) {
//         const userData = await response.json();
//         setUserDetails(userData);
        
//         // Update email in password data if not already set
//         if (userData.email && !passwordData.email) {
//           setPasswordData(prev => ({
//             ...prev,
//             email: userData.email
//           }));
//         }
//       } else {
//         console.warn('Failed to fetch user details:', response.status);
//       }
//     } catch (error) {
//       console.error('Error fetching user details:', error);
//     } finally {
//       setFetchingUser(false);
//     }
//   };

//   useEffect(() => {
//     // Fetch user details when component mounts or user prop changes
//     if (user?.id) {
//       fetchUserDetails();
//     }
//   }, [user?.id]);

//   const handlePasswordChange = (e) => {
//     const { name, value } = e.target;
//     setPasswordData(prev => ({
//       ...prev,
//       [name]: value
//     }));

//     if (name === 'newPassword') {
//       checkPasswordStrength(value);
//     }
//   };

//   const checkPasswordStrength = (password) => {
//     let strength = 0;
    
//     if (password.length >= 8) strength += 25;
//     if (/[a-z]/.test(password)) strength += 25;
//     if (/[A-Z]/.test(password)) strength += 25;
//     if (/[0-9]/.test(password) || /[^A-Za-z0-9]/.test(password)) strength += 25;
    
//     setPasswordStrength(strength);
//   };

//   const getPasswordStrengthColor = () => {
//     if (passwordStrength < 50) return '#e74c3c';
//     if (passwordStrength < 75) return '#f39c12';
//     return '#27ae60';
//   };

//   const getPasswordStrengthText = () => {
//     if (passwordStrength === 0) return '';
//     if (passwordStrength < 50) return 'Weak';
//     if (passwordStrength < 75) return 'Medium';
//     return 'Strong';
//   };

//   const startResendCooldown = () => {
//     setResendCooldown(30);
//     const timer = setInterval(() => {
//       setResendCooldown((prev) => {
//         if (prev <= 1) {
//           clearInterval(timer);
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);
//   };

//   const sendOTP = async () => {
//     try {
//       setLoading(true);
//       setMessage({ type: '', text: '' });

//       // Validate email
//       if (!passwordData.email) {
//         swal('Error', 'Please enter your email address', 'error');
//         setLoading(false);
//         return;
//       }

//       if (!/\S+@\S+\.\S+/.test(passwordData.email)) {
//         swal('Error', 'Please enter a valid email address', 'error');
//         setLoading(false);
//         return;
//       }

//       const response = await fetch(`${API_BASE_URL}/api/users/forgot-password`, {
//         method: 'POST',
//         headers: { 
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ email: passwordData.email }),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         swal('Success', 'OTP sent to your email! Check your inbox and terminal.', 'success');
//         setStep(2);
//         startResendCooldown();
//       } else {
//         // Even if backend says email not found, we proceed to show OTP step (security)
//         swal('Success', 'If the email exists in our system, an OTP has been sent. Check your terminal for development.', 'success');
//         setStep(2);
//         startResendCooldown();
//       }
//     } catch (error) {
//       swal('Error', 'Failed to send OTP. Please try again.', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleResendOTP = async () => {
//     if (resendCooldown > 0) return;
//     await sendOTP();
//   };

//   const verifyOTPAndResetPassword = async (e) => {
//     e.preventDefault();
    
//     if (!otp || otp.length !== 6) {
//       swal('Error', 'Please enter a valid 6-digit OTP', 'error');
//       return;
//     }

//     try {
//       setLoading(true);
//       setMessage({ type: '', text: '' });

//       // Verify OTP first
//       const verifyResponse = await fetch(`${API_BASE_URL}/api/users/verify-otp`, {
//         method: 'POST',
//         headers: { 
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ 
//           email: passwordData.email, 
//           otp: otp 
//         }),
//       });

//       const verifyData = await verifyResponse.json();

//       if (!verifyResponse.ok) {
//         swal('Error', verifyData.error || 'Invalid OTP', 'error');
//         setLoading(false);
//         return;
//       }

//       // OTP verified, now reset password
//       const resetResponse = await fetch(`${API_BASE_URL}/api/users/reset-password`, {
//         method: 'POST',
//         headers: { 
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ 
//           email: passwordData.email,
//           otp: otp,
//           password: passwordData.newPassword,
//           confirm_password: passwordData.confirmPassword
//         }),
//       });

//       const resetData = await resetResponse.json();

//       if (resetResponse.ok) {
//         swal('Success', 'Password updated successfully!', 'success');
        
//         // Clear form
//         setPasswordData({
//           currentPassword: '',
//           newPassword: '',
//           confirmPassword: '',
//           email: userDetails?.email || user?.email || ''
//         });
//         setOtp('');
//         setStep(1);
//         setPasswordStrength(0);
        
//       } else {
//         swal('Error', resetData.error || 'Failed to reset password', 'error');
//       }
//     } catch (error) {
//       swal('Error', 'An error occurred during password reset', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
    
//     // Validation
//     if (!passwordData.currentPassword) {
//       swal('Error', 'Current password is required', 'error');
//       return;
//     }

//     if (!passwordData.email) {
//       swal('Error', 'Email address is required', 'error');
//       return;
//     }

//     if (passwordData.newPassword !== passwordData.confirmPassword) {
//       swal('Error', 'New passwords do not match', 'error');
//       return;
//     }

//     if (passwordData.newPassword.length < 6) {
//       swal('Error', 'Password must be at least 6 characters long', 'error');
//       return;
//     }

//     if (passwordStrength < 50) {
//       swal('Error', 'Please choose a stronger password', 'error');
//       return;
//     }

//     // Verify current password first
//     try {
//       setLoading(true);
//       setMessage({ type: '', text: '' });

//       const verifyResponse = await fetch(`${API_BASE_URL}/api/users/login`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           username: user?.username || passwordData.email, // Use email if username not available
//           password: passwordData.currentPassword
//         }),
//       });

//       if (!verifyResponse.ok) {
//         swal('Error', 'Current password is incorrect', 'error');
//         setLoading(false);
//         return;
//       }

//       // Current password is correct, send OTP
//       await sendOTP();
//     } catch (error) {
//       swal('Error', 'Failed to verify current password', 'error');
//       setLoading(false);
//     }
//   };

//   const togglePasswordVisibility = (field) => {
//     switch (field) {
//       case 'current':
//         setShowCurrentPassword(!showCurrentPassword);
//         break;
//       case 'new':
//         setShowNewPassword(!showNewPassword);
//         break;
//       case 'confirm':
//         setShowConfirmPassword(!showConfirmPassword);
//         break;
//       default:
//         break;
//     }
//   };

//   const handleBackToPassword = () => {
//     setStep(1);
//     setOtp('');
//   };

//   const refreshUserEmail = () => {
//     fetchUserDetails();
//   };

//   // Determine the display email (prefer fetched email, then prop email)
//   const displayEmail = userDetails?.email || user?.email || passwordData.email;

//   return (
//     <div style={styles.pageContainer}>
//       <div style={styles.backgroundAnimation}>
//         <div style={styles.orb1}></div>
//         <div style={styles.orb2}></div>
//         <div style={styles.orb3}></div>
//       </div>
      
//       <div style={styles.container}>
//         <div style={styles.header}>
//           <div style={styles.avatarSection}>
//             <div style={styles.avatar}>
//               {user?.first_name?.charAt(0) || 'U'}{user?.last_name?.charAt(0) || 'S'}
//             </div>
//             <div style={styles.userInfo}>
//               <h1 style={styles.title}>Account Settings</h1>
//               <p style={styles.subtitle}>
//                 {displayEmail || 'Update your account security settings'}
//                 {fetchingUser && <span style={styles.loadingText}> (Loading...)</span>}
//               </p>
//             </div>
//           </div>
//           <div style={styles.securityBadge}>
//             <span style={styles.badgeIcon}>🔒</span>
//             Secure Session
//           </div>
//         </div>

//         <div style={styles.settingsCard}>
//           {/* Step 1: Password Form */}
//           {step === 1 && (
//             <div style={styles.section}>
//               <div style={styles.sectionHeader}>
//                 <h2 style={styles.sectionTitle}>
//                   <span style={styles.titleIcon}>🔑</span>
//                   Change Password
//                 </h2>
//                 <div style={styles.stepIndicator}>
//                   <span style={styles.stepActive}>1</span>
//                   <span style={styles.stepInactive}>2</span>
//                 </div>
//               </div>
              
//               <p style={styles.sectionDescription}>
//                 Secure your account with a new password. You'll receive a verification code for security.
//               </p>

//               {/* Email Refresh Button */}
//               {user?.id && (
//                 <div style={styles.refreshEmailSection}>
//                   <button
//                     type="button"
//                     onClick={refreshUserEmail}
//                     disabled={fetchingUser}
//                     style={styles.refreshEmailButton}
//                   >
//                     {fetchingUser ? '🔄 Loading...' : '🔄 Refresh Email from Server'}
//                   </button>
//                   {userDetails?.email && (
//                     <div style={styles.emailSource}>
//                       ✅ Email loaded from server
//                     </div>
//                   )}
//                 </div>
//               )}
              
//               <form onSubmit={handlePasswordSubmit} style={styles.form}>
//                 {/* Email Input Field */}
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>
//                     <span style={styles.labelIcon}>📧</span>
//                     Email Address for OTP
//                   </label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={userDetails?.email}
//                     onChange={handlePasswordChange}
//                     required
//                     style={styles.emailInput}
//                     placeholder={fetchingUser ? "Loading email..." : "Enter your registered email address"}
//                     disabled={loading || fetchingUser}
//                   />
//                   <div style={styles.emailNote}>
//                     {displayEmail ? 
//                       `We'll send the verification code to: ${displayEmail}` : 
//                       'We\'ll send the verification code to this email address'
//                     }
//                   </div>
//                 </div>

//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>
//                     <span style={styles.labelIcon}>🔒</span>
//                     Current Password
//                   </label>
//                   <div style={styles.passwordContainer}>
//                     <input
//                       type={showCurrentPassword ? "text" : "password"}
//                       name="currentPassword"
//                       value={passwordData.currentPassword}
//                       onChange={handlePasswordChange}
//                       required
//                       style={styles.passwordInput}
//                       placeholder="Enter your current password"
//                       disabled={loading}
//                     />
//                     <button
//                       type="button"
//                       onClick={() => togglePasswordVisibility('current')}
//                       style={styles.visibilityButton}
//                       disabled={loading}
//                     >
//                       {showCurrentPassword ? '🙈' : '👁️'}
//                     </button>
//                   </div>
//                 </div>

//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>
//                     <span style={styles.labelIcon}>🔄</span>
//                     New Password
//                   </label>
//                   <div style={styles.passwordContainer}>
//                     <input
//                       type={showNewPassword ? "text" : "password"}
//                       name="newPassword"
//                       value={passwordData.newPassword}
//                       onChange={handlePasswordChange}
//                       required
//                       style={styles.passwordInput}
//                       placeholder="Create a strong new password"
//                       disabled={loading}
//                     />
//                     <button
//                       type="button"
//                       onClick={() => togglePasswordVisibility('new')}
//                       style={styles.visibilityButton}
//                       disabled={loading}
//                     >
//                       {showNewPassword ? '🙈' : '👁️'}
//                     </button>
//                   </div>
                  
//                   {passwordData.newPassword && (
//                     <div style={styles.passwordStrength}>
//                       <div style={styles.strengthBar}>
//                         <div 
//                           style={{
//                             ...styles.strengthFill,
//                             width: `${passwordStrength}%`,
//                             backgroundColor: getPasswordStrengthColor()
//                           }}
//                         ></div>
//                       </div>
//                       <div style={styles.strengthInfo}>
//                         <span style={styles.strengthText}>
//                           {getPasswordStrengthText()}
//                         </span>
//                         <span style={styles.strengthPercentage}>
//                           {passwordStrength}%
//                         </span>
//                       </div>
//                     </div>
//                   )}
//                 </div>

//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>
//                     <span style={styles.labelIcon}>✅</span>
//                     Confirm New Password
//                   </label>
//                   <div style={styles.passwordContainer}>
//                     <input
//                       type={showConfirmPassword ? "text" : "password"}
//                       name="confirmPassword"
//                       value={passwordData.confirmPassword}
//                       onChange={handlePasswordChange}
//                       required
//                       style={{
//                         ...styles.passwordInput,
//                         borderColor: passwordData.confirmPassword && 
//                                     passwordData.newPassword !== passwordData.confirmPassword ? 
//                                     '#e74c3c' : 
//                                     passwordData.confirmPassword && 
//                                     passwordData.newPassword === passwordData.confirmPassword ?
//                                     '#27ae60' : '#e0e0e0'
//                       }}
//                       placeholder="Confirm your new password"
//                       disabled={loading}
//                     />
//                     <button
//                       type="button"
//                       onClick={() => togglePasswordVisibility('confirm')}
//                       style={styles.visibilityButton}
//                       disabled={loading}
//                     >
//                       {showConfirmPassword ? '🙈' : '👁️'}
//                     </button>
//                   </div>
                  
//                   {passwordData.confirmPassword && passwordData.newPassword !== passwordData.confirmPassword && (
//                     <div style={styles.errorText}>❌ Passwords do not match</div>
//                   )}
//                   {passwordData.confirmPassword && passwordData.newPassword === passwordData.confirmPassword && (
//                     <div style={styles.successText}>✅ Passwords match</div>
//                   )}
//                 </div>

//                 <button
//                   type="submit"
//                   disabled={loading || !passwordData.email}
//                   style={{
//                     ...styles.submitButton,
//                     ...(loading || !passwordData.email ? styles.buttonDisabled : {})
//                   }}
//                 >
//                   {loading ? (
//                     <>
//                       <span style={styles.spinner}></span>
//                       Verifying...
//                     </>
//                   ) : (
//                     <>
//                       <span style={styles.buttonIcon}>📧</span>
//                       Send Verification Code
//                     </>
//                   )}
//                 </button>
//               </form>
//             </div>
//           )}

//           {/* Step 2: OTP Verification */}
//           {step === 2 && (
//             <div style={styles.section}>
//               <div style={styles.sectionHeader}>
//                 <h2 style={styles.sectionTitle}>
//                   <span style={styles.titleIcon}>🔐</span>
//                   Verify Identity
//                 </h2>
//                 <div style={styles.stepIndicator}>
//                   <span style={styles.stepCompleted}>✓</span>
//                   <span style={styles.stepActive}>2</span>
//                 </div>
//               </div>
              
//               <div style={styles.emailConfirmation}>
//                 <div style={styles.emailConfirmationIcon}>📧</div>
//                 <div>
//                   <strong>Code sent to:</strong> {passwordData.email}
//                 </div>
//               </div>

//               <p style={styles.sectionDescription}>
//                 We've sent a 6-digit verification code to your email address. 
//                 Please enter it below to complete the password reset.
//               </p>

//               <div style={styles.otpNote}>
//                 <div style={styles.otpNoteIcon}>💡</div>
//                 <div>
//                   <strong>Development Note:</strong> If email fails, check your terminal for the OTP code
//                 </div>
//               </div>

//               <form onSubmit={verifyOTPAndResetPassword} style={styles.form}>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>
//                     <span style={styles.labelIcon}>🔢</span>
//                     Verification Code
//                   </label>
//                   <input
//                     type="text"
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
//                     required
//                     style={styles.otpInput}
//                     placeholder="Enter 6-digit code"
//                     maxLength={6}
//                     disabled={loading}
//                   />
//                   <div style={styles.otpInfo}>
//                     <div style={styles.otpTimer}>
//                       ⏰ Code expires in 15 minutes
//                     </div>
//                   </div>
//                 </div>

//                 <div style={styles.resendContainer}>
//                   <button 
//                     type="button" 
//                     onClick={handleResendOTP}
//                     disabled={resendCooldown > 0 || loading}
//                     style={{
//                       ...styles.resendButton,
//                       ...((resendCooldown > 0 || loading) ? styles.resendButtonDisabled : {})
//                     }}
//                   >
//                     {resendCooldown > 0 ? `Resend code in ${resendCooldown}s` : "Resend Code"}
//                   </button>
//                 </div>

//                 <div style={styles.buttonGroup}>
//                   <button
//                     type="button"
//                     onClick={handleBackToPassword}
//                     style={styles.backButton}
//                     disabled={loading}
//                   >
//                     ← Back
//                   </button>
                  
//                   <button
//                     type="submit"
//                     disabled={loading || otp.length !== 6}
//                     style={{
//                       ...styles.submitButton,
//                       ...((loading || otp.length !== 6) ? styles.buttonDisabled : {})
//                     }}
//                   >
//                     {loading ? (
//                       <>
//                         <span style={styles.spinner}></span>
//                         Updating...
//                       </>
//                     ) : (
//                       <>
//                         <span style={styles.buttonIcon}>🔄</span>
//                         Update Password
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           )}

//           {/* Security Tips */}
//           <div style={styles.tipsSection}>
//             <h3 style={styles.tipsTitle}>💡 Security Best Practices</h3>
//             <div style={styles.tipsGrid}>
//               <div style={styles.tipCard}>
//                 <div style={styles.tipIcon}>🎯</div>
//                 <h4 style={styles.tipTitle}>Use Registered Email</h4>
//                 <p style={styles.tipText}>Always use the email address associated with your account</p>
//               </div>
              
//               <div style={styles.tipCard}>
//                 <div style={styles.tipIcon}>🔄</div>
//                 <h4 style={styles.tipTitle}>Regular Updates</h4>
//                 <p style={styles.tipText}>Change your password every 3-6 months</p>
//               </div>
              
//               <div style={styles.tipCard}>
//                 <div style={styles.tipIcon}>🚫</div>
//                 <h4 style={styles.tipTitle}>Avoid Reuse</h4>
//                 <p style={styles.tipText}>Don't use the same password across multiple sites</p>
//               </div>
              
//               <div style={styles.tipCard}>
//                 <div style={styles.tipIcon}>📧</div>
//                 <h4 style={styles.tipTitle}>Check Spam Folder</h4>
//                 <p style={styles.tipText}>If you don't see the OTP, check your spam/junk folder</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Add CSS animations */}
//       <style>{`
//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
//         @keyframes float {
//           0%, 100% { transform: translateY(0px) scale(1); }
//           50% { transform: translateY(-20px) scale(1.05); }
//         }
//       `}</style>
//     </div>
//   );
// };

// const styles = {
//   pageContainer: {
//     minHeight: '100vh',
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     position: 'relative',
//     overflow: 'hidden',
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
//   },
//   backgroundAnimation: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     zIndex: 1
//   },
//   orb1: {
//     position: 'absolute',
//     width: '200px',
//     height: '200px',
//     borderRadius: '50%',
//     background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%)',
//     top: '10%',
//     left: '10%',
//     animation: 'float 6s ease-in-out infinite'
//   },
//   orb2: {
//     position: 'absolute',
//     width: '150px',
//     height: '150px',
//     borderRadius: '50%',
//     background: 'radial-gradient(circle, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0) 70%)',
//     top: '60%',
//     right: '15%',
//     animation: 'float 8s ease-in-out infinite 2s'
//   },
//   orb3: {
//     position: 'absolute',
//     width: '100px',
//     height: '100px',
//     borderRadius: '50%',
//     background: 'radial-gradient(circle, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0) 70%)',
//     bottom: '20%',
//     left: '20%',
//     animation: 'float 10s ease-in-out infinite 1s'
//   },
//   container: {
//     position: 'relative',
//     zIndex: 2,
//     maxWidth: '800px',
//     margin: '0 auto',
//     padding: '40px 20px',
//   },
//   header: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'flex-start',
//     marginBottom: '30px',
//     flexWrap: 'wrap',
//     gap: '20px'
//   },
//   avatarSection: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '20px'
//   },
//   avatar: {
//     width: '80px',
//     height: '80px',
//     borderRadius: '50%',
//     background: 'linear-gradient(135deg, #667eea, #764ba2)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '28px',
//     fontWeight: 'bold',
//     color: 'white',
//     boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
//   },
//   userInfo: {
//     color: 'white'
//   },
//   title: {
//     fontSize: '2.5rem',
//     fontWeight: '700',
//     margin: '0 0 8px 0',
//     textShadow: '0 2px 10px rgba(0,0,0,0.3)'
//   },
//   subtitle: {
//     fontSize: '1.2rem',
//     margin: 0,
//     opacity: 0.9,
//     fontWeight: '300'
//   },
//   loadingText: {
//     fontSize: '0.9rem',
//     opacity: 0.7,
//     fontStyle: 'italic'
//   },
//   securityBadge: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
//     backgroundColor: 'rgba(255,255,255,0.2)',
//     color: 'white',
//     padding: '12px 20px',
//     borderRadius: '25px',
//     fontSize: '16px',
//     fontWeight: '600',
//     backdropFilter: 'blur(10px)',
//     border: '1px solid rgba(255,255,255,0.3)'
//   },
//   badgeIcon: {
//     fontSize: '18px'
//   },
//   settingsCard: {
//     backgroundColor: 'rgba(255, 255, 255, 0.95)',
//     borderRadius: '25px',
//     padding: '40px',
//     boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
//     backdropFilter: 'blur(20px)',
//     border: '1px solid rgba(255, 255, 255, 0.3)'
//   },
//   section: {
//     marginBottom: '40px'
//   },
//   sectionHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '20px',
//     flexWrap: 'wrap',
//     gap: '15px'
//   },
//   sectionTitle: {
//     fontSize: '1.8rem',
//     fontWeight: '600',
//     color: '#2c3e50',
//     margin: 0,
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px'
//   },
//   titleIcon: {
//     fontSize: '24px'
//   },
//   stepIndicator: {
//     display: 'flex',
//     gap: '8px',
//     alignItems: 'center'
//   },
//   stepActive: {
//     width: '35px',
//     height: '35px',
//     borderRadius: '50%',
//     backgroundColor: '#667eea',
//     color: 'white',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontWeight: '600',
//     fontSize: '14px',
//     boxShadow: '0 4px 10px rgba(102, 126, 234, 0.3)'
//   },
//   stepInactive: {
//     width: '35px',
//     height: '35px',
//     borderRadius: '50%',
//     backgroundColor: '#e0e0e0',
//     color: '#666',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontWeight: '600',
//     fontSize: '14px'
//   },
//   stepCompleted: {
//     width: '35px',
//     height: '35px',
//     borderRadius: '50%',
//     backgroundColor: '#27ae60',
//     color: 'white',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontWeight: '600',
//     fontSize: '14px',
//     boxShadow: '0 4px 10px rgba(39, 174, 96, 0.3)'
//   },
//   sectionDescription: {
//     fontSize: '1.1rem',
//     color: '#7f8c8d',
//     margin: '0 0 30px 0',
//     lineHeight: '1.6'
//   },
//   refreshEmailSection: {
//     backgroundColor: '#e3f2fd',
//     border: '1px solid #bbdefb',
//     borderRadius: '12px',
//     padding: '15px',
//     marginBottom: '20px',
//     textAlign: 'center'
//   },
//   refreshEmailButton: {
//     backgroundColor: '#2196f3',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     padding: '10px 16px',
//     fontSize: '14px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     marginBottom: '8px'
//   },
//   emailSource: {
//     fontSize: '12px',
//     color: '#1976d2',
//     fontWeight: '500'
//   },
//   emailConfirmation: {
//     backgroundColor: '#e8f5e8',
//     border: '1px solid #c3e6cb',
//     borderRadius: '12px',
//     padding: '15px',
//     fontSize: '14px',
//     color: '#155724',
//     marginBottom: '20px',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px'
//   },
//   emailConfirmationIcon: {
//     fontSize: '18px',
//     flexShrink: 0
//   },
//   otpNote: {
//     backgroundColor: '#fff3cd',
//     border: '1px solid #ffeaa7',
//     borderRadius: '12px',
//     padding: '15px',
//     fontSize: '14px',
//     color: '#856404',
//     marginBottom: '25px',
//     display: 'flex',
//     alignItems: 'flex-start',
//     gap: '12px'
//   },
//   otpNoteIcon: {
//     fontSize: '18px',
//     flexShrink: 0
//   },
//   form: {
//     maxWidth: '500px'
//   },
//   formGroup: {
//     marginBottom: '25px'
//   },
//   label: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
//     marginBottom: '12px',
//     fontWeight: '600',
//     color: '#2c3e50',
//     fontSize: '15px'
//   },
//   labelIcon: {
//     fontSize: '16px'
//   },
//   emailInput: {
//     width: '100%',
//     padding: '16px 20px',
//     border: '2px solid #e0e0e0',
//     borderRadius: '12px',
//     fontSize: '16px',
//     transition: 'all 0.3s ease',
//     boxSizing: 'border-box',
//     backgroundColor: '#fff',
//     fontFamily: 'inherit'
//   },
//   emailNote: {
//     fontSize: '12px',
//     color: '#7f8c8d',
//     marginTop: '8px',
//     fontStyle: 'italic'
//   },
//   passwordContainer: {
//     position: 'relative',
//     display: 'flex',
//     alignItems: 'center'
//   },
//   passwordInput: {
//     width: '100%',
//     padding: '16px 50px 16px 20px',
//     border: '2px solid #e0e0e0',
//     borderRadius: '12px',
//     fontSize: '16px',
//     transition: 'all 0.3s ease',
//     boxSizing: 'border-box',
//     backgroundColor: '#fff',
//     fontFamily: 'inherit'
//   },
//   otpInput: {
//     width: '100%',
//     padding: '18px',
//     border: '2px solid #e0e0e0',
//     borderRadius: '12px',
//     fontSize: '20px',
//     textAlign: 'center',
//     letterSpacing: '10px',
//     fontWeight: '600',
//     transition: 'all 0.3s ease',
//     boxSizing: 'border-box',
//     backgroundColor: '#fff',
//     fontFamily: 'monospace'
//   },
//   visibilityButton: {
//     position: 'absolute',
//     right: '15px',
//     background: 'none',
//     border: 'none',
//     fontSize: '20px',
//     cursor: 'pointer',
//     padding: '8px',
//     borderRadius: '8px',
//     transition: 'background-color 0.2s',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center'
//   },
//   passwordStrength: {
//     marginTop: '12px'
//   },
//   strengthBar: {
//     width: '100%',
//     height: '8px',
//     backgroundColor: '#ecf0f1',
//     borderRadius: '4px',
//     overflow: 'hidden',
//     marginBottom: '8px'
//   },
//   strengthFill: {
//     height: '100%',
//     transition: 'all 0.3s ease',
//     borderRadius: '4px'
//   },
//   strengthInfo: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center'
//   },
//   strengthText: {
//     fontSize: '13px',
//     color: '#7f8c8d',
//     fontWeight: '600',
//     textTransform: 'uppercase'
//   },
//   strengthPercentage: {
//     fontSize: '12px',
//     color: '#7f8c8d',
//     fontWeight: '500'
//   },
//   errorText: {
//     color: '#e74c3c',
//     fontSize: '13px',
//     marginTop: '8px',
//     fontWeight: '500',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '6px'
//   },
//   successText: {
//     color: '#27ae60',
//     fontSize: '13px',
//     marginTop: '8px',
//     fontWeight: '500',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '6px'
//   },
//   otpInfo: {
//     marginTop: '12px',
//     textAlign: 'center'
//   },
//   otpTimer: {
//     fontSize: '14px',
//     color: '#666',
//     fontWeight: '500'
//   },
//   resendContainer: {
//     marginBottom: '25px',
//     textAlign: 'center'
//   },
//   resendButton: {
//     backgroundColor: 'transparent',
//     color: '#667eea',
//     border: '2px solid #667eea',
//     borderRadius: '10px',
//     padding: '12px 24px',
//     fontSize: '15px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     fontFamily: 'inherit'
//   },
//   resendButtonDisabled: {
//     color: '#a0a0a0',
//     borderColor: '#a0a0a0',
//     cursor: 'not-allowed'
//   },
//   buttonGroup: {
//     display: 'flex',
//     gap: '15px'
//   },
//   backButton: {
//     flex: 1,
//     padding: '16px',
//     backgroundColor: 'transparent',
//     color: '#667eea',
//     border: '2px solid #667eea',
//     borderRadius: '12px',
//     cursor: 'pointer',
//     fontSize: '16px',
//     fontWeight: '600',
//     transition: 'all 0.3s ease',
//     fontFamily: 'inherit'
//   },
//   submitButton: {
//     flex: 2,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     gap: '10px',
//     padding: '16px',
//     backgroundColor: '#667eea',
//     color: 'white',
//     border: 'none',
//     borderRadius: '12px',
//     cursor: 'pointer',
//     fontSize: '16px',
//     fontWeight: '600',
//     transition: 'all 0.3s ease',
//     boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
//     fontFamily: 'inherit'
//   },
//   buttonDisabled: {
//     backgroundColor: '#a0a0a0',
//     cursor: 'not-allowed',
//     boxShadow: 'none'
//   },
//   buttonIcon: {
//     fontSize: '18px'
//   },
//   spinner: {
//     width: '20px',
//     height: '20px',
//     border: '2px solid transparent',
//     borderTop: '2px solid currentColor',
//     borderRadius: '50%',
//     animation: 'spin 1s linear infinite'
//   },
//   tipsSection: {
//     borderTop: '2px solid #f8f9fa',
//     paddingTop: '30px'
//   },
//   tipsTitle: {
//     fontSize: '1.4rem',
//     fontWeight: '600',
//     color: '#2c3e50',
//     margin: '0 0 25px 0',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px'
//   },
//   tipsGrid: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//     gap: '20px'
//   },
//   tipCard: {
//     backgroundColor: '#f8f9fa',
//     padding: '25px',
//     borderRadius: '15px',
//     textAlign: 'center',
//     transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//     cursor: 'pointer'
//   },
//   tipIcon: {
//     fontSize: '32px',
//     marginBottom: '15px'
//   },
//   tipTitle: {
//     fontSize: '16px',
//     fontWeight: '600',
//     color: '#2c3e50',
//     margin: '0 0 10px 0'
//   },
//   tipText: {
//     fontSize: '14px',
//     color: '#7f8c8d',
//     margin: 0,
//     lineHeight: '1.5'
//   }
// };

// export default Settings;



import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';

const Settings = ({ user }) => {
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    email: user?.email || '' // Pre-fill with user's email or empty
  });
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState(1); // 1: Password form, 2: OTP verification
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [resendCooldown, setResendCooldown] = useState(0);
  const [userDetails, setUserDetails] = useState(null);
  const [fetchingUser, setFetchingUser] = useState(false);

  const API_BASE_URL = "https://dairy.server.statify.co.ke";

  // Color constants
  const PRIMARY_COLOR = "#024A59";
  const SECONDARY_COLOR = "#FFA916";
  const LIGHT_PRIMARY = "#03718C";
  const LIGHT_SECONDARY = "#FFBA4D";

  // Fetch user details including email from backend
  const fetchUserDetails = async () => {
    if (!user?.id) return;
    
    try {
      setFetchingUser(true);
      const token = localStorage.getItem('token');
      
      if (!token) {
        console.warn('No authentication token found');
        return;
      }

      const response = await fetch(`${API_BASE_URL}/api/users/${user.id}`, {
        method: 'GET',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });

      if (response.ok) {
        const userData = await response.json();
        setUserDetails(userData);
        
        // Update email in password data if not already set
        if (userData.email && !passwordData.email) {
          setPasswordData(prev => ({
            ...prev,
            email: userData.email
          }));
        }
      } else {
        console.warn('Failed to fetch user details:', response.status);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    } finally {
      setFetchingUser(false);
    }
  };

  useEffect(() => {
    // Fetch user details when component mounts or user prop changes
    if (user?.id) {
      fetchUserDetails();
    }
  }, [user?.id]);

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prev => ({
      ...prev,
      [name]: value
    }));

    if (name === 'newPassword') {
      checkPasswordStrength(value);
    }
  };

  const checkPasswordStrength = (password) => {
    let strength = 0;
    
    if (password.length >= 8) strength += 25;
    if (/[a-z]/.test(password)) strength += 25;
    if (/[A-Z]/.test(password)) strength += 25;
    if (/[0-9]/.test(password) || /[^A-Za-z0-9]/.test(password)) strength += 25;
    
    setPasswordStrength(strength);
  };

  const getPasswordStrengthColor = () => {
    if (passwordStrength < 50) return '#e74c3c';
    if (passwordStrength < 75) return SECONDARY_COLOR;
    return '#27ae60';
  };

  const getPasswordStrengthText = () => {
    if (passwordStrength === 0) return '';
    if (passwordStrength < 50) return 'Weak';
    if (passwordStrength < 75) return 'Medium';
    return 'Strong';
  };

  const startResendCooldown = () => {
    setResendCooldown(30);
    const timer = setInterval(() => {
      setResendCooldown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const sendOTP = async () => {
    try {
      setLoading(true);
      setMessage({ type: '', text: '' });

      // Validate email
      if (!passwordData.email) {
        swal('Error', 'Please enter your email address', 'error');
        setLoading(false);
        return;
      }

      if (!/\S+@\S+\.\S+/.test(passwordData.email)) {
        swal('Error', 'Please enter a valid email address', 'error');
        setLoading(false);
        return;
      }

      const response = await fetch(`${API_BASE_URL}/api/users/forgot-password`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: passwordData.email }),
      });

      const data = await response.json();

      if (response.ok) {
        swal('Success', 'OTP sent to your email! Check your inbox and terminal.', 'success');
        setStep(2);
        startResendCooldown();
      } else {
        // Even if backend says email not found, we proceed to show OTP step (security)
        swal('Success', 'If the email exists in our system, an OTP has been sent. Check your terminal for development.', 'success');
        setStep(2);
        startResendCooldown();
      }
    } catch (error) {
      swal('Error', 'Failed to send OTP. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    if (resendCooldown > 0) return;
    await sendOTP();
  };

  const verifyOTPAndResetPassword = async (e) => {
    e.preventDefault();
    
    if (!otp || otp.length !== 6) {
      swal('Error', 'Please enter a valid 6-digit OTP', 'error');
      return;
    }

    try {
      setLoading(true);
      setMessage({ type: '', text: '' });

      // Verify OTP first
      const verifyResponse = await fetch(`${API_BASE_URL}/api/users/verify-otp`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          email: passwordData.email, 
          otp: otp 
        }),
      });

      const verifyData = await verifyResponse.json();

      if (!verifyResponse.ok) {
        swal('Error', verifyData.error || 'Invalid OTP', 'error');
        setLoading(false);
        return;
      }

      // OTP verified, now reset password
      const resetResponse = await fetch(`${API_BASE_URL}/api/users/reset-password`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          email: passwordData.email,
          otp: otp,
          password: passwordData.newPassword,
          confirm_password: passwordData.confirmPassword
        }),
      });

      const resetData = await resetResponse.json();

      if (resetResponse.ok) {
        swal('Success', 'Password updated successfully!', 'success');
        
        // Clear form
        setPasswordData({
          currentPassword: '',
          newPassword: '',
          confirmPassword: '',
          email: userDetails?.email || user?.email || ''
        });
        setOtp('');
        setStep(1);
        setPasswordStrength(0);
        
      } else {
        swal('Error', resetData.error || 'Failed to reset password', 'error');
      }
    } catch (error) {
      swal('Error', 'An error occurred during password reset', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!passwordData.currentPassword) {
      swal('Error', 'Current password is required', 'error');
      return;
    }

    if (!passwordData.email) {
      swal('Error', 'Email address is required', 'error');
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      swal('Error', 'New passwords do not match', 'error');
      return;
    }

    if (passwordData.newPassword.length < 6) {
      swal('Error', 'Password must be at least 6 characters long', 'error');
      return;
    }

    if (passwordStrength < 50) {
      swal('Error', 'Please choose a stronger password', 'error');
      return;
    }

    // Verify current password first
    try {
      setLoading(true);
      setMessage({ type: '', text: '' });

      const verifyResponse = await fetch(`${API_BASE_URL}/api/users/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: user?.username || passwordData.email, // Use email if username not available
          password: passwordData.currentPassword
        }),
      });

      if (!verifyResponse.ok) {
        swal('Error', 'Current password is incorrect', 'error');
        setLoading(false);
        return;
      }

      // Current password is correct, send OTP
      await sendOTP();
    } catch (error) {
      swal('Error', 'Failed to verify current password', 'error');
      setLoading(false);
    }
  };

  const togglePasswordVisibility = (field) => {
    switch (field) {
      case 'current':
        setShowCurrentPassword(!showCurrentPassword);
        break;
      case 'new':
        setShowNewPassword(!showNewPassword);
        break;
      case 'confirm':
        setShowConfirmPassword(!showConfirmPassword);
        break;
      default:
        break;
    }
  };

  const handleBackToPassword = () => {
    setStep(1);
    setOtp('');
  };

  const refreshUserEmail = () => {
    fetchUserDetails();
  };

  // Determine the display email (prefer fetched email, then prop email)
  const displayEmail = userDetails?.email || user?.email || passwordData.email;

  return (
    <div style={styles.pageContainer}>
      <div style={styles.backgroundAnimation}>
        <div style={styles.orb1}></div>
        <div style={styles.orb2}></div>
        <div style={styles.orb3}></div>
      </div>
      
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={styles.avatarSection}>
            <div style={styles.avatar}>
              {user?.first_name?.charAt(0) || 'U'}{user?.last_name?.charAt(0) || 'S'}
            </div>
            <div style={styles.userInfo}>
              <h1 style={styles.title}>Account Settings</h1>
              <p style={styles.subtitle}>
                {displayEmail || 'Update your account security settings'}
                {fetchingUser && <span style={styles.loadingText}> (Loading...)</span>}
              </p>
            </div>
          </div>
          <div style={styles.securityBadge}>
            <span style={styles.badgeIcon}>🔒</span>
            Secure Session
          </div>
        </div>

        <div style={styles.settingsCard}>
          {/* Step 1: Password Form */}
          {step === 1 && (
            <div style={styles.section}>
              <div style={styles.sectionHeader}>
                <h2 style={styles.sectionTitle}>
                  <span style={styles.titleIcon}>🔑</span>
                  Change Password
                </h2>
                <div style={styles.stepIndicator}>
                  <span style={styles.stepActive}>1</span>
                  <span style={styles.stepInactive}>2</span>
                </div>
              </div>
              
              <p style={styles.sectionDescription}>
                Secure your account with a new password. You'll receive a verification code for security.
              </p>

              {/* Email Refresh Button */}
              {user?.id && (
                <div style={styles.refreshEmailSection}>
                  <button
                    type="button"
                    onClick={refreshUserEmail}
                    disabled={fetchingUser}
                    style={styles.refreshEmailButton}
                  >
                    {fetchingUser ? '🔄 Loading...' : '🔄 Refresh Email from Server'}
                  </button>
                  {userDetails?.email && (
                    <div style={styles.emailSource}>
                      ✅ Email loaded from server
                    </div>
                  )}
                </div>
              )}
              
              <form onSubmit={handlePasswordSubmit} style={styles.form}>
                {/* Email Input Field */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    <span style={styles.labelIcon}>📧</span>
                    Email Address for OTP
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={userDetails?.email}
                    onChange={handlePasswordChange}
                    required
                    style={styles.emailInput}
                    placeholder={fetchingUser ? "Loading email..." : "Enter your registered email address"}
                    disabled={loading || fetchingUser}
                  />
                  <div style={styles.emailNote}>
                    {displayEmail ? 
                      `We'll send the verification code to: ${displayEmail}` : 
                      'We\'ll send the verification code to this email address'
                    }
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    <span style={styles.labelIcon}>🔒</span>
                    Current Password
                  </label>
                  <div style={styles.passwordContainer}>
                    <input
                      type={showCurrentPassword ? "text" : "password"}
                      name="currentPassword"
                      value={passwordData.currentPassword}
                      onChange={handlePasswordChange}
                      required
                      style={styles.passwordInput}
                      placeholder="Enter your current password"
                      disabled={loading}
                    />
                    <button
                      type="button"
                      onClick={() => togglePasswordVisibility('current')}
                      style={styles.visibilityButton}
                      disabled={loading}
                    >
                      {showCurrentPassword ? '🙈' : '👁️'}
                    </button>
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    <span style={styles.labelIcon}>🔄</span>
                    New Password
                  </label>
                  <div style={styles.passwordContainer}>
                    <input
                      type={showNewPassword ? "text" : "password"}
                      name="newPassword"
                      value={passwordData.newPassword}
                      onChange={handlePasswordChange}
                      required
                      style={styles.passwordInput}
                      placeholder="Create a strong new password"
                      disabled={loading}
                    />
                    <button
                      type="button"
                      onClick={() => togglePasswordVisibility('new')}
                      style={styles.visibilityButton}
                      disabled={loading}
                    >
                      {showNewPassword ? '🙈' : '👁️'}
                    </button>
                  </div>
                  
                  {passwordData.newPassword && (
                    <div style={styles.passwordStrength}>
                      <div style={styles.strengthBar}>
                        <div 
                          style={{
                            ...styles.strengthFill,
                            width: `${passwordStrength}%`,
                            backgroundColor: getPasswordStrengthColor()
                          }}
                        ></div>
                      </div>
                      <div style={styles.strengthInfo}>
                        <span style={styles.strengthText}>
                          {getPasswordStrengthText()}
                        </span>
                        <span style={styles.strengthPercentage}>
                          {passwordStrength}%
                        </span>
                      </div>
                    </div>
                  )}
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    <span style={styles.labelIcon}>✅</span>
                    Confirm New Password
                  </label>
                  <div style={styles.passwordContainer}>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      value={passwordData.confirmPassword}
                      onChange={handlePasswordChange}
                      required
                      style={{
                        ...styles.passwordInput,
                        borderColor: passwordData.confirmPassword && 
                                    passwordData.newPassword !== passwordData.confirmPassword ? 
                                    '#e74c3c' : 
                                    passwordData.confirmPassword && 
                                    passwordData.newPassword === passwordData.confirmPassword ?
                                    '#27ae60' : '#e0e0e0'
                      }}
                      placeholder="Confirm your new password"
                      disabled={loading}
                    />
                    <button
                      type="button"
                      onClick={() => togglePasswordVisibility('confirm')}
                      style={styles.visibilityButton}
                      disabled={loading}
                    >
                      {showConfirmPassword ? '🙈' : '👁️'}
                    </button>
                  </div>
                  
                  {passwordData.confirmPassword && passwordData.newPassword !== passwordData.confirmPassword && (
                    <div style={styles.errorText}>❌ Passwords do not match</div>
                  )}
                  {passwordData.confirmPassword && passwordData.newPassword === passwordData.confirmPassword && (
                    <div style={styles.successText}>✅ Passwords match</div>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={loading || !passwordData.email}
                  style={{
                    ...styles.submitButton,
                    ...(loading || !passwordData.email ? styles.buttonDisabled : {})
                  }}
                >
                  {loading ? (
                    <>
                      <span style={styles.spinner}></span>
                      Verifying...
                    </>
                  ) : (
                    <>
                      <span style={styles.buttonIcon}>📧</span>
                      Send Verification Code
                    </>
                  )}
                </button>
              </form>
            </div>
          )}

          {/* Step 2: OTP Verification */}
          {step === 2 && (
            <div style={styles.section}>
              <div style={styles.sectionHeader}>
                <h2 style={styles.sectionTitle}>
                  <span style={styles.titleIcon}>🔐</span>
                  Verify Identity
                </h2>
                <div style={styles.stepIndicator}>
                  <span style={styles.stepCompleted}>✓</span>
                  <span style={styles.stepActive}>2</span>
                </div>
              </div>
              
              <div style={styles.emailConfirmation}>
                <div style={styles.emailConfirmationIcon}>📧</div>
                <div>
                  <strong>Code sent to:</strong> {passwordData.email}
                </div>
              </div>

              <p style={styles.sectionDescription}>
                We've sent a 6-digit verification code to your email address. 
                Please enter it below to complete the password reset.
              </p>

              <div style={styles.otpNote}>
                <div style={styles.otpNoteIcon}>💡</div>
                <div>
                  <strong>Development Note:</strong> If email fails, check your terminal for the OTP code
                </div>
              </div>

              <form onSubmit={verifyOTPAndResetPassword} style={styles.form}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    <span style={styles.labelIcon}>🔢</span>
                    Verification Code
                  </label>
                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    required
                    style={styles.otpInput}
                    placeholder="Enter 6-digit code"
                    maxLength={6}
                    disabled={loading}
                  />
                  <div style={styles.otpInfo}>
                    <div style={styles.otpTimer}>
                      ⏰ Code expires in 15 minutes
                    </div>
                  </div>
                </div>

                <div style={styles.resendContainer}>
                  <button 
                    type="button" 
                    onClick={handleResendOTP}
                    disabled={resendCooldown > 0 || loading}
                    style={{
                      ...styles.resendButton,
                      ...((resendCooldown > 0 || loading) ? styles.resendButtonDisabled : {})
                    }}
                  >
                    {resendCooldown > 0 ? `Resend code in ${resendCooldown}s` : "Resend Code"}
                  </button>
                </div>

                <div style={styles.buttonGroup}>
                  <button
                    type="button"
                    onClick={handleBackToPassword}
                    style={styles.backButton}
                    disabled={loading}
                  >
                    ← Back
                  </button>
                  
                  <button
                    type="submit"
                    disabled={loading || otp.length !== 6}
                    style={{
                      ...styles.submitButton,
                      ...((loading || otp.length !== 6) ? styles.buttonDisabled : {})
                    }}
                  >
                    {loading ? (
                      <>
                        <span style={styles.spinner}></span>
                        Updating...
                      </>
                    ) : (
                      <>
                        <span style={styles.buttonIcon}>🔄</span>
                        Update Password
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Security Tips */}
          <div style={styles.tipsSection}>
            <h3 style={styles.tipsTitle}>💡 Security Best Practices</h3>
            <div style={styles.tipsGrid}>
              <div style={styles.tipCard}>
                <div style={styles.tipIcon}>🎯</div>
                <h4 style={styles.tipTitle}>Use Registered Email</h4>
                <p style={styles.tipText}>Always use the email address associated with your account</p>
              </div>
              
              <div style={styles.tipCard}>
                <div style={styles.tipIcon}>🔄</div>
                <h4 style={styles.tipTitle}>Regular Updates</h4>
                <p style={styles.tipText}>Change your password every 3-6 months</p>
              </div>
              
              <div style={styles.tipCard}>
                <div style={styles.tipIcon}>🚫</div>
                <h4 style={styles.tipTitle}>Avoid Reuse</h4>
                <p style={styles.tipText}>Don't use the same password across multiple sites</p>
              </div>
              
              <div style={styles.tipCard}>
                <div style={styles.tipIcon}>📧</div>
                <h4 style={styles.tipTitle}>Check Spam Folder</h4>
                <p style={styles.tipText}>If you don't see the OTP, check your spam/junk folder</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add CSS animations */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px) scale(1); }
          50% { transform: translateY(-20px) scale(1.05); }
        }
      `}</style>
    </div>
  );
};

const styles = {
  pageContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #024A59 0%, #03718C 100%)',
    position: 'relative',
    overflow: 'hidden',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  },
  backgroundAnimation: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1
  },
  orb1: {
    position: 'absolute',
    width: '200px',
    height: '200px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(255,169,22,0.1) 0%, rgba(255,255,255,0) 70%)',
    top: '10%',
    left: '10%',
    animation: 'float 6s ease-in-out infinite'
  },
  orb2: {
    position: 'absolute',
    width: '150px',
    height: '150px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(2,74,89,0.08) 0%, rgba(255,255,255,0) 70%)',
    top: '60%',
    right: '15%',
    animation: 'float 8s ease-in-out infinite 2s'
  },
  orb3: {
    position: 'absolute',
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(255,169,22,0.06) 0%, rgba(255,255,255,0) 70%)',
    bottom: '20%',
    left: '20%',
    animation: 'float 10s ease-in-out infinite 1s'
  },
  container: {
    position: 'relative',
    zIndex: 2,
    maxWidth: '800px',
    margin: '0 auto',
    padding: '40px 20px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '30px',
    flexWrap: 'wrap',
    gap: '20px'
  },
  avatarSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px'
  },
  avatar: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #024A59, #FFA916)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '28px',
    fontWeight: 'bold',
    color: 'white',
    boxShadow: '0 8px 25px rgba(2,74,89,0.3)'
  },
  userInfo: {
    color: 'white'
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: '700',
    margin: '0 0 8px 0',
    textShadow: '0 2px 10px rgba(0,0,0,0.3)'
  },
  subtitle: {
    fontSize: '1.2rem',
    margin: 0,
    opacity: 0.9,
    fontWeight: '300'
  },
  loadingText: {
    fontSize: '0.9rem',
    opacity: 0.7,
    fontStyle: 'italic'
  },
  securityBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: 'rgba(255,169,22,0.2)',
    color: '#FFA916',
    padding: '12px 20px',
    borderRadius: '25px',
    fontSize: '16px',
    fontWeight: '600',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255,169,22,0.3)'
  },
  badgeIcon: {
    fontSize: '18px'
  },
  settingsCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '25px',
    padding: '40px',
    boxShadow: '0 20px 60px rgba(2,74,89,0.1)',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.3)'
  },
  section: {
    marginBottom: '40px'
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    flexWrap: 'wrap',
    gap: '15px'
  },
  sectionTitle: {
    fontSize: '1.8rem',
    fontWeight: '600',
    color: '#024A59',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  titleIcon: {
    fontSize: '24px'
  },
  stepIndicator: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  stepActive: {
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    backgroundColor: '#024A59',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '600',
    fontSize: '14px',
    boxShadow: '0 4px 10px rgba(2,74,89,0.3)'
  },
  stepInactive: {
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    backgroundColor: '#e0e0e0',
    color: '#666',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '600',
    fontSize: '14px'
  },
  stepCompleted: {
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    backgroundColor: '#27ae60',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '600',
    fontSize: '14px',
    boxShadow: '0 4px 10px rgba(39, 174, 96, 0.3)'
  },
  sectionDescription: {
    fontSize: '1.1rem',
    color: '#7f8c8d',
    margin: '0 0 30px 0',
    lineHeight: '1.6'
  },
  refreshEmailSection: {
    backgroundColor: '#e3f2fd',
    border: '1px solid #bbdefb',
    borderRadius: '12px',
    padding: '15px',
    marginBottom: '20px',
    textAlign: 'center'
  },
  refreshEmailButton: {
    backgroundColor: '#024A59',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 16px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginBottom: '8px'
  },
  emailSource: {
    fontSize: '12px',
    color: '#024A59',
    fontWeight: '500'
  },
  emailConfirmation: {
    backgroundColor: '#e8f5e8',
    border: '1px solid #c3e6cb',
    borderRadius: '12px',
    padding: '15px',
    fontSize: '14px',
    color: '#155724',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  emailConfirmationIcon: {
    fontSize: '18px',
    flexShrink: 0
  },
  otpNote: {
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeaa7',
    borderRadius: '12px',
    padding: '15px',
    fontSize: '14px',
    color: '#856404',
    marginBottom: '25px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px'
  },
  otpNoteIcon: {
    fontSize: '18px',
    flexShrink: 0
  },
  form: {
    maxWidth: '500px'
  },
  formGroup: {
    marginBottom: '25px'
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '12px',
    fontWeight: '600',
    color: '#024A59',
    fontSize: '15px'
  },
  labelIcon: {
    fontSize: '16px'
  },
  emailInput: {
    width: '100%',
    padding: '16px 20px',
    border: '2px solid #e0e0e0',
    borderRadius: '12px',
    fontSize: '16px',
    transition: 'all 0.3s ease',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    fontFamily: 'inherit'
  },
  emailNote: {
    fontSize: '12px',
    color: '#7f8c8d',
    marginTop: '8px',
    fontStyle: 'italic'
  },
  passwordContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  passwordInput: {
    width: '100%',
    padding: '16px 50px 16px 20px',
    border: '2px solid #e0e0e0',
    borderRadius: '12px',
    fontSize: '16px',
    transition: 'all 0.3s ease',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    fontFamily: 'inherit'
  },
  otpInput: {
    width: '100%',
    padding: '18px',
    border: '2px solid #e0e0e0',
    borderRadius: '12px',
    fontSize: '20px',
    textAlign: 'center',
    letterSpacing: '10px',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    fontFamily: 'monospace'
  },
  visibilityButton: {
    position: 'absolute',
    right: '15px',
    background: 'none',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '8px',
    transition: 'background-color 0.2s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  passwordStrength: {
    marginTop: '12px'
  },
  strengthBar: {
    width: '100%',
    height: '8px',
    backgroundColor: '#ecf0f1',
    borderRadius: '4px',
    overflow: 'hidden',
    marginBottom: '8px'
  },
  strengthFill: {
    height: '100%',
    transition: 'all 0.3s ease',
    borderRadius: '4px'
  },
  strengthInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  strengthText: {
    fontSize: '13px',
    color: '#7f8c8d',
    fontWeight: '600',
    textTransform: 'uppercase'
  },
  strengthPercentage: {
    fontSize: '12px',
    color: '#7f8c8d',
    fontWeight: '500'
  },
  errorText: {
    color: '#e74c3c',
    fontSize: '13px',
    marginTop: '8px',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  successText: {
    color: '#27ae60',
    fontSize: '13px',
    marginTop: '8px',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  otpInfo: {
    marginTop: '12px',
    textAlign: 'center'
  },
  otpTimer: {
    fontSize: '14px',
    color: '#666',
    fontWeight: '500'
  },
  resendContainer: {
    marginBottom: '25px',
    textAlign: 'center'
  },
  resendButton: {
    backgroundColor: 'transparent',
    color: '#024A59',
    border: '2px solid #024A59',
    borderRadius: '10px',
    padding: '12px 24px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    fontFamily: 'inherit'
  },
  resendButtonDisabled: {
    color: '#a0a0a0',
    borderColor: '#a0a0a0',
    cursor: 'not-allowed'
  },
  buttonGroup: {
    display: 'flex',
    gap: '15px'
  },
  backButton: {
    flex: 1,
    padding: '16px',
    backgroundColor: 'transparent',
    color: '#024A59',
    border: '2px solid #024A59',
    borderRadius: '12px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    fontFamily: 'inherit'
  },
  submitButton: {
    flex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    padding: '16px',
    backgroundColor: '#024A59',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 15px rgba(2,74,89,0.3)',
    fontFamily: 'inherit'
  },
  buttonDisabled: {
    backgroundColor: '#a0a0a0',
    cursor: 'not-allowed',
    boxShadow: 'none'
  },
  buttonIcon: {
    fontSize: '18px'
  },
  spinner: {
    width: '20px',
    height: '20px',
    border: '2px solid transparent',
    borderTop: '2px solid currentColor',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },
  tipsSection: {
    borderTop: '2px solid rgba(2,74,89,0.1)',
    paddingTop: '30px'
  },
  tipsTitle: {
    fontSize: '1.4rem',
    fontWeight: '600',
    color: '#024A59',
    margin: '0 0 25px 0',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  tipsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px'
  },
  tipCard: {
    backgroundColor: '#f8f9fa',
    padding: '25px',
    borderRadius: '15px',
    textAlign: 'center',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    cursor: 'pointer'
  },
  tipIcon: {
    fontSize: '32px',
    marginBottom: '15px'
  },
  tipTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#024A59',
    margin: '0 0 10px 0'
  },
  tipText: {
    fontSize: '14px',
    color: '#7f8c8d',
    margin: 0,
    lineHeight: '1.5'
  }
};

export default Settings;